import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Observable, Subject, Subscription, catchError, distinctUntilChanged, filter, finalize, map, of, switchMap, takeUntil, tap } from 'rxjs';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { environment } from 'src/environments/environment';
import { RequestsService } from './requests.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { RequestDetailsComponent } from './request-details/request-details.component';
import { AddRequestComponent } from './add-request/add-request.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { helper } from 'src/environments/helper';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { CerereStatusService } from '../../settings-sidenav/cerere-status/cerere-status.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { CerereTypeService } from '../../settings-sidenav/cerere-type/cerere-type.service';
import { UpdateRequestStatusComponent } from './update-request-status/update-request-status.component';
import { AssignRequestComponent } from './assign-request/assign-request.component';
import { Cerere } from './request.interface';
import { MatCalendar } from '@angular/material/datepicker';
import { NotificationService } from 'src/app/services/notification.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { StorageService } from 'src/app/utils/storage/storage.service';
@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
})
export class RequestsComponent implements OnInit, OnDestroy {
    private readonly _destroying$ = new Subject<void>();

    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;
    helper = helper;
    editorConfig!: AngularEditorConfig;

    userId: number = -1;
    userDepartament: number = -1;

    isLoading = false;
    isFilterLoading = false;
    showCard = false;
    checkboxSelections = false;
    rowCount = 0;

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(new Date().getFullYear(), 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.rerenderDT();
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.rerenderDT();
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    // Date popover filtering

    dateFilteringOptions: string[] = [
        'Adăugare',
        'Actualizare',
        'Validare',
        'Invalidare/Anulare',
        'Finalizare',
    ];

    dateFilterOption: string = 'Adăugare';

    // Values for status filtering
    defaultParameter: { name: string; id: string } = {
        name: 'Toate',
        id: '-1',
    };

    selectedStatusID: string = this.defaultParameter.id;
    // statusParametersValue!: string;

    // Values for category filtering
    categoryToggleOptions = [
        { id: -1, value: 'Toate' },
        { id: 1, value: 'Departamentele mele' },
        { id: 2, value: 'Cererile mele' },
        { id: 3, value: 'Mesaje interne' },
    ];

    selectedCategory: string | number = this.categoryToggleOptions[0].id;

    // Value for notification filtering
    notificationParameter: { id: string; name: string } = { id: '-1', name: '' };

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    directiiActive: Generic[] = [];
    compartimenteActive!: Generic[];

    private destroy$ = new Subject<void>();

    // Filtered fields for search
    filteredDirectii!: any[];
    directiiControl = new FormControl();

    filteredCompartimente: any[] = [];
    compartimenteControl = new FormControl();

    statusCerere!: Generic[];
    requestTypes!: any;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    toggleCard() {
        this.showCard = !this.showCard;
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    searchParamsForm!: FormGroup;

    //Form Initial Values

    initialFormValues = {
        directieValue: -1,
        compartimentValue: -1,
        numarCerere: '',
        numarCerereIntern: '',
        cnp_cui: '',
        denumire_cetatean: '',
        email_cetatean: '',
        tip_cerere: '-1',
        validated: '-1',
        invalidated: '-1',
        finalizat_lucrare: '-1',
    };

    cerereStatusControl: AbstractControl = new FormControl('');
    // directieControl: AbstractControl = new FormControl('');
    // assignedId: AbstractControl = new FormControl('');
    // internalMessages: AbstractControl = new FormControl('');

    buildSearchParamsForm() {
        this.searchParamsForm = new FormGroup({
            directieValue: new FormControl(-1),
            compartimentValue: new FormControl(-1),
            numarCerere: new FormControl(''),
            numarCerereIntern: new FormControl(''),
            cnp_cui: new FormControl(''),
            denumire_cetatean: new FormControl(''),
            email_cetatean: new FormControl(''),
            tip_cerere: new FormControl('-1'),
            validated: new FormControl('-1'),
            invalidated: new FormControl('-1'),
            finalizat_lucrare: new FormControl('-1'),
            user_assigned_id: new FormControl('-1'),
            internal_messages: new FormControl('-1'),
        });

        this.cerereStatusControl = this.searchParamsForm.get(
            'cerereStatus'
        ) as AbstractControl;
        // this.directieControl = this.searchParamsForm.get(
        //     'directieValue'
        // ) as AbstractControl;
        // this.assignedId = this.searchParamsForm.get(
        //     'user_assigned_id'
        // ) as AbstractControl;
        // this.internalMessages = this.searchParamsForm.get(
        //     'internal_messages'
        // ) as AbstractControl;
    }

    resetForm() {
        this.searchParamsForm.reset(this.initialFormValues);
        this.onDirectieChange(-1);

        this.filteredDirectii = this.directiiActive;
        this.directiiControl.setValue(null);

        this.compartimenteControl.setValue(null);

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    // Info for conditional assign and change status from DT

    selectedRowIds: number[] = [];

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.cereri.getCereriListDT;

    notificationServiceBefore: any = {
        currentStatus: -1,
        currentCategory: -1,
    }

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private requestsService: RequestsService,
        private cerereStatusService: CerereStatusService,
        private cerereTypeService: CerereTypeService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
        private storageService: StorageService
    ) {
        this.tomorrow.setDate(this.today.getDate() + 1);
    }

    ngOnInit(): void {
        this.loadRequestTypes();
        this.loadRequestStatuses();
        this.renderDT();
        this.loadDirectiiActive();
        this.editorConfig = initializeEditor();
        this.buildSearchParamsForm();
        this.getUserDetails();
        this.redirectFromNotifications();
        this.renderFieldsSearch();
    }

    redirectFromNotifications() {
        this.notificationService.currentNotification
            .pipe(takeUntil(this._destroying$))
            .subscribe(
                (notification: { id: string; name: string }) => {
                    if (notification) {
                        this.notificationParameter = notification;

                        this.notificationServiceBefore.currentStatus = this.selectedStatusID;
                        this.notificationServiceBefore.currentCategory = this.selectedCategory;

                        this.selectedStatusID = '-1';
                        this.selectedCategory = -1;

                        this.rerenderDT();
                    }
                }
            );
    }

    removeChip(): void {
        // Resets the notification parameter which we send to our backend with -1 so the filter for this particular flag is canceled
        this.notificationParameter = { id: '-1', name: '' };
        this.notificationService.changeNotification(this.notificationParameter); // notifications - clear notifications selection from service
        // here we need to update our buttons
        this.selectedStatusID = this.notificationServiceBefore.currentStatus;
        this.selectedCategory = this.notificationServiceBefore.currentCategory;

        this.rerenderDT();
    }

    renderFieldsSearch() {
        this.directiiControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredDirectii = this.directiiActive;
                    return of(this.directiiActive);
                }
                return this.filterDirectii(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectii = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.compartimenteControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            switchMap((inputValue) => {
                if (inputValue.length < 1) {
                    this.filteredCompartimente = this.compartimenteActive;
                    return of(this.compartimenteActive);
                }
                return this.filterCompartimente(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredCompartimente = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    loadDirectiiActive() {
        this.isFilterLoading = true;
        this.requestsService
            .getDirectii()
            .pipe(
                map((results: any) => [...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.directiiActive = results;
                    this.filteredDirectii = results;
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.isFilterLoading = false;
                },
            });
    }

    filterDirectii(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiActive.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    onDirectieSelectClosed() {
        const selectedValue = this.directiiControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredDirectii.some(categorie =>
                categorie.id === this.searchParamsForm.get('directieValue')?.value
            );

            if (!isSelectedInFilteredList) {
                this.directiiControl.setValue(null);
                this.filteredDirectii = this.directiiActive;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    onDirectieChange(directieId: number): void {
        this.searchParamsForm.controls['compartimentValue'].patchValue(-1);

        if (directieId == -1) {
            this.compartimenteActive = [];
            this.filteredCompartimente = [];
            return;
        }

        if (directieId) {
            this.loadCompartimenteActive(directieId);
        }
    }

    loadCompartimenteActive(directieId?: number) {
        this.isFilterLoading = true;
        let compartimenteObservable$ = directieId
            ? this.requestsService.getCompartimenteByDirectieId(directieId)
            : this.requestsService.getCompartimenteActive();

        compartimenteObservable$.pipe(
            map((results: any) => [...results]),
            finalize(() => {
                this.isFilterLoading = false;
            })
        ).subscribe({
            next: (compartimente) => {
                this.compartimenteActive = [...compartimente];
                this.filteredCompartimente = [...compartimente];
            },
            error: (err) => {
                console.log(err);
                this.filteredCompartimente = [];
            }
        });
    }

    onCompartimenteSelectClosed() {
        const selectedValue = this.compartimenteControl.value;

        if (selectedValue) {
            const isSelectedInFilteredList = this.filteredCompartimente.some(compartiment =>
                compartiment.id === this.searchParamsForm.get('compartimentValue')?.value
            );

            if (!isSelectedInFilteredList) {
                this.compartimenteControl.setValue(null);
                this.filteredCompartimente = this.compartimenteActive;
                this.destroy$.next();
                this.destroy$.complete();
                this.renderFieldsSearch();
            }
        }
    }

    filterCompartimente(searchTerm: string): Observable<Generic[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        return of(this.compartimenteActive.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        ));
    }

    loadRequestStatuses() {
        this.isFilterLoading = true;
        this.cerereStatusService
            .getStatuses()
            .pipe(
                map((results: any) => [this.defaultParameter, ...results]),
                finalize(() => (this.isFilterLoading = false))
            )
            .subscribe({
                next: (results) => {
                    this.statusCerere = results;
                },
                error: (error) => {
                    console.error('Error loading cerere status', error);
                    this.isFilterLoading = false;
                },
            });
    }

    loadRequestTypes() {
        this.cerereTypeService.getRequestTypes().subscribe((data) => {
            this.requestTypes = data;
        });
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
        this.notificationService.changeNotification({ id: '-1', name: '' }); // notifications - clear notifications selection from service

        this.destroy$.next();
        this.destroy$.complete();
    }

    renderDT() {
        const self = this;
        this.isLoading = true;

        this.dtOptions = {
            order: [[1, 'desc']],
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.status = this.selectedStatusID;
                dataTablesParameters.categoryStatus = this.selectedCategory;
                dataTablesParameters.filters = this.searchParamsForm.value;
                dataTablesParameters.dateFilter = this.dateFilterOption;
                dataTablesParameters.date_from = this.formatDate(
                    this.selectedStartDate
                );
                dataTablesParameters.date_to = this.formatDate(this.selectedEndDate);
                dataTablesParameters.notificationParameter =
                    this.notificationParameter.id;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        this.getTableRowCount();
                        this.checkboxesReset();

                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columnDefs: [
                { width: '3%', targets: 0 },
                { width: '15%', targets: 1 },
                { width: '20%', targets: 2 },
                { width: '15%', targets: 3 },
                { width: '19%', targets: 4 },
                { width: '11%', targets: 5 },
                { width: '15%', targets: 6 },
            ],

            columns: [
                {
                    title: `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" id="headerCheckbox"/>`,
                    data: 'id',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `<input type="checkbox" class="row-checkbox" style="width: 20px; height: 20px;" value="${row.id}" />`
                    }
                },
                {
                    title: `ID`,
                    data: 'id',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let source = row.source_name.toUpperCase();
                        let color = row.source_color;
                        let flagIcon = '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        return `
                            <div style="display: flex; align-items: center; gap: 5px;">
                            <span>${row.indoc_number ? row.indoc_number : 'N/A'}</span>
                            <span>/</span>
                            <span>${row.created}</span>
                            </div>
                            <div> <br/>
                                <span  style="padding: 3px 6px; background-color: #bdbdbd; border: 0px;border-radius:10px">I: ${row.id}</span>
                                <span style="color: ${color}; font-weight: 700;">&nbsp${source}</span>
                            </div>
                            ` + (row.mesajeInterne == 1 ?
                                `<div> <br/><span  style="padding: 4px 6px; color: white; background-color: red; border: 0px;border-radius:10px">${flagIcon} Mesaj intern</span>
                                </div>`
                                : '') + `
                        `;
                    },
                },
                {
                    title: 'Tip solicitare',
                    data: 'subject',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';
                        return `
							<span><strong>${row.subject}</strong></span><br/><br/>
							<span style="color:#bdbdbd; font-size:12px"> Categorie / Tip</span><br/>
							<span>
							<img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_directie} <br/>
							<img src="${imageTreeUrl}" alt="Image" style="width: 20px; height: 20px;">
							${row.categorie_compartiment}</span><br/><br/>
						`;
                    },
                },
                {
                    title: 'Identificare',
                    data: 'denumire_cetatean',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-user.svg';
                        return `
                <span style="color:#bdbdbd; font-size:12px"> Cetățean/Societate</span><br/>
                <img src="${imageUrl}" alt="Image" style="width: 20px; height: 20px;">
                <span>${row.denumire_cetatean}</span><br/>
            `;
                    },
                },
                {
                    title: 'Atribuire',
                    data: 'user_assigned',
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        const imageUrl = '/assets/icons/icon-addcard.svg';
                        const imageTreeUrl = '/assets/icons/icon-tree.svg';
                        return `
                              <span style="color:#bdbdbd; font-size:12px">Locație Solicitare</span><br/>
                              <span style="color:#bdbdbd; font-size:12px">Instituție</span><br/>
                              <span style="font-weight:600 font-size:16px">${row.directie
                                ? row.directie
                                : 'n/a'
                            }</span><br/>
                              <span style="color:#bdbdbd; font-size:12px">Serviciu/Birou/Departament</span><br/>
                              <span>${row.compartiment
                                ? row.compartiment
                                : 'n/a'
                            }</span><br/>
                              <span style="color:#bdbdbd; font-size:12px">Operator Asignat</span><br/>
                              <span>${row.user_assigned}</span>
                          `;
                    },
                },
                {
                    title:
                        'Prioritate',
                    data: 'priority_name',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        return `
                        <span style="border-radius:10px; padding:4px 8px; color: ${row.priority_color}; background: ${row.priority_bg_color}">${row.priority_name}</span><br/><br/>
                        <span style="color:#bdbdbd; font-size:12px">SLA</span><br/>
                        <span>${row.sla}</span><br/>
                    `;
                    },
                },
                {
                    title: 'Status',

                    data: 'updated_at',
                    sortable: true,
                    render: (data: any, type: any, row: any) => {
                        let label = '';
                        let flagIcon =
                            '<i class="fa-solid fa-flag" style="color: white;"></i> ';
                        if (row.validated_date && !row.cancel_date) {
                            // Validat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: green">${flagIcon}Validat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 1) {
                            // Invalidat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: orange">${flagIcon}Invalidat</span>`;
                        } else if (row.cancel_date && row.cancel_type === 2) {
                            // Clasat
                            label = `<span style="border-radius:10px; padding:4px 8px; color: white; background: red">${flagIcon}Clasat</span>`;
                        } else {
                            // Default case
                            label = ``;
                        }
                        return `
                            <span style="border-radius:10px; padding:4px 8px; color: ${row.status_color}; background: ${row.status_bg_color}">${row.status_name}</span><br/><br/>
                            <span style="color:#bdbdbd; font-size:12px">Ultima actualizare</span><br/>
                            <span>${row.updated}</span><br/>
                            <br/>${label}
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                // Handle click event on the CHECKBOXES
                $(row)
                    .find('.row-checkbox')
                    .off('change')
                    .on('change', function () {
                        let idCerere = Number($(this).val());

                        if ($(this).is(':checked')) {
                            self.selectedRowIds.push(idCerere);
                        } else {
                            self.selectedRowIds = self.selectedRowIds.filter(
                                (id) => id !== idCerere
                            );
                        }

                        if (self.rowCount !== self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(false);
                        } else if (self.rowCount === self.selectedRowIds.length) {
                            self.checkHeaderCheckBox(true);
                        }

                        self.checkboxSelections = self.selectedRowIds.length > 0;
                    });

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data);
                });

                return row;
            },
            headerCallback: (row: Node, data: any[] | any) => {
                const headerCheckbox = $(row).find('#headerCheckbox');

                // Remove any existing event handlers to avoid duplicating them
                headerCheckbox.off('change click');

                // Handle the change event for selecting/deselecting all checkboxes
                headerCheckbox.on('change', function () {
                    if ($(this).is(':checked')) {
                        self.selectedRowIds.length = 0;
                        data.forEach((item: Cerere) => {
                            self.selectedRowIds.push(item.id);
                        });
                        self.checkMultipleCheckboxesByValue(true);
                    } else {
                        self.selectedRowIds.length = 0;
                        self.checkMultipleCheckboxesByValue(false);
                    }
                    self.checkboxSelections = self.selectedRowIds.length > 0;
                });

                // Prevent sorting when clicking the checkbox
                headerCheckbox.on('click', function (e) {
                    e.stopPropagation();
                });

                return row;
            },
        };
    }

    async getTableRowCount() {
        const table = await this.dtElement.dtInstance;
        this.rowCount = table.rows().count();
    }

    checkHeaderCheckBox(checkValue: boolean) {
        const headerCheckbox = document.getElementById(
            'headerCheckbox'
        ) as HTMLInputElement;
        headerCheckbox.checked = checkValue;
    }
    checkMultipleCheckboxesByValue(checkValue: boolean) {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[type="checkbox"]'
        );
        checkboxes.forEach((checkbox) => {
            checkbox.checked = checkValue;
        });
    }
    checkboxesReset() {
        this.selectedRowIds.length = 0;
        this.checkMultipleCheckboxesByValue(false);
        this.checkHeaderCheckBox(false);
        this.checkboxSelections = false;
    }

    onRowClick(rowData: Request) {
        this.closePopover();
        this.openInfoDialog(rowData);
    }

    rerenderDT(paginate = false): void {
        // notifications - skip rerender when dt is not loaded. Rerender is called by notificationService.currentNotification subscription.
        if (!this.dtElement || !this.dtElement.dtInstance) return;

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    /* Removed this functionality until further notice
      openAddDialog() {
        const dialogRef = this.dialog.open(AddRequestComponent, {
        ...this.dialogService.getDialogConfig(),
        });
      
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
        if (success) {
          this.rerenderDT();
        }
        });
      }
      */
    openChangeStatusComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(UpdateRequestStatusComponent, {
                ...this.dialogService.getDialogConfig(),
                data: this.selectedRowIds,
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openReassignComponent() {
        if (this.selectedRowIds.length > 0) {
            const dialogRef = this.dialog.open(AssignRequestComponent, {
                ...this.dialogService.getDialogConfig(),
                data: {
                    selectedRowIds: this.selectedRowIds,
                    directiiActive: this.directiiActive,
                }
            });

            dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
                if (success) {
                    this.rerenderDT();
                }
            });
        }
    }

    openInfoDialog(data: any) {
        const dialogRef = this.dialog.open(RequestDetailsComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data: {
                cerere: data,
                directii: this.directiiActive,
                statusCerere: this.statusCerere,
            }
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            this.rerenderDT();
        });
    }

    onStatusChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedStatusID = event.value;
        this.cerereStatusControl?.setValue(this.selectedStatusID);

        // this.statusParametersValue = event.value === 'toate' ? '-1' : '1';
        this.rerenderDT();
    }

    onCategoryChange(event: MatButtonToggleChange) {
        this.isLoading = true;
        this.selectedCategory = event.value;
        this.rerenderDT();
    }

    getUserDetails() {
        const userObj = this.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.userId = val.id_user;
                this.userDepartament = val.id_department;
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
